(ns minorodata.app.model
  (:require [mold.core :as m :refer-macros [defmodel]]))

(declare ->app-route ->snack ->app ->timezones)

(defmodel app-route
  {:name    [::m/keyword "Route name"]
   :params  [::m/map ::m/nilable "Route params map"]
   :query   [::m/map ::m/nilable "Route query map"]
   :options [::m/map ::m/nilable "Options for UI"]}
  {:singleton true})


(defmodel snack
  {:message    [::m/string "Showed to users text"]
   :persistent [::m/bool "If true don't hide it automatically"]
   :active     [::m/bool "Visible flag"]
   :type       [::m/keyword "One of :error :info :success :warning"]
   :action     [::m/vector "Additional action to dispatch"]
   :metadata   [::m/map ::m/nilable "Metadata"]})


(defmodel app
  {:ready? [::m/bool "Is app ready to interaction"]
   :dark-mode? [::m/bool "Dark mode"]}
  {:singleton true})

(m/defmodel timezones
  {:data   [::m/vector "Array of preferences"]}
  {:singleton true})
